module.exports = __webpack_public_path__ + "static/media/4.928acfb4.png";